import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, AlertController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data'
import { HomePage } from '../home/home'
import { LoginParams } from '../../models/apiResponse';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  public account: LoginParams = {
    username: "",
    password: ""
  };
  //"despachodeviajes",
  //"despachodeviajes"

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private menuCtrl: MenuController, private dataProvider: DataProvider, public alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }

  public doLogin() {
    this.dataProvider.logOn(this.account).subscribe((success) => {
      if (success) {
        this.menuCtrl.enable(true, 'myMenu');
        this.navCtrl.setRoot(HomePage);
      } else {
        const alert = this.alertCtrl.create({
          title: 'Inicio de sesión',
          subTitle: 'Los datos son incorrectos',
          buttons: ['OK'],
        });
        alert.present();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts